import { U, matchedRoleFor, roleStats } from "./accessors";
import type { InfiniteWarState, IwTeam, IwUnit } from "./types";

/**
 * Kill → non-interactive soul residue → tier-matched rebirth for killer faction.
 * Demigods never enter this path.
 */
export function killUnit(state: InfiniteWarState, unit: IwUnit, killer: IwTeam): void {
  if (unit.phase !== "alive") return;
  const stats = roleStats(unit.roleId);
  if (stats.tags.includes("demigod")) return;
  const pendingRoleId = matchedRoleFor(unit.roleId, killer);
  unit.phase = "soul";
  unit.killerTeam = killer;
  unit.soulRemain = U.soulGrantDelaySec;
  unit.hp = 0;
  unit.attackCooldown = 0;
  unit.intentVx = 0;
  unit.intentVy = 0;
  unit.engageTargetId = null;
  state.conversions[killer] += 1;
  state.events.push({
    kind: "soul_fall",
    team: killer,
    x: unit.x,
    y: unit.y,
    roleId: unit.roleId,
    pendingRoleId,
  });
}

/** Advance soul residues; rebirth as killer-faction unit of matched tier at death site. */
export function tickSouls(state: InfiniteWarState, step: number): void {
  for (const unit of state.units) {
    if (unit.phase !== "soul") continue;
    unit.soulRemain -= step;
    if (unit.soulRemain > 0) continue;
    const killer = unit.killerTeam!;
    const fromRoleId = unit.roleId;
    const toRoleId = matchedRoleFor(fromRoleId, killer);
    const born = roleStats(toRoleId);
    unit.team = killer;
    unit.roleId = toRoleId;
    unit.hp = born.hp;
    unit.maxHp = born.hp;
    unit.phase = "alive";
    unit.killerTeam = null;
    unit.soulRemain = 0;
    unit.attackCooldown = 0.3;
    unit.intentVx = 0;
    unit.intentVy = 0;
    unit.facingX = 0;
    unit.facingY = killer === "south" ? -1 : 1;
    unit.blight = 0;
    unit.buffMul = 1;
    unit.engageTargetId = null;
    state.events.push({
      kind: "soul_harvest",
      team: killer,
      x: unit.x,
      y: unit.y,
      fromRoleId,
      roleId: toRoleId,
    });
  }
}

export function soulResidueCount(state: InfiniteWarState): number {
  return state.units.filter((u) => u.phase === "soul").length;
}

export function soulResidueCountFor(state: InfiniteWarState, team: IwTeam): number {
  return state.units.filter((u) => u.phase === "soul" && u.killerTeam === team).length;
}
